import { INVALID, VALID } from '../PropertyValidationStatus';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { INVALID_BILLING_TERM_FREQUENCY_RATIO } from '../PropertyValidationErrorCodes';
import { doesBillingFrequencyEvenlyDividePeriod } from '../../v2/utils/period';
import { jsx as _jsx } from "react/jsx-runtime";
const createValidationDetails = validationRequest => {
  const {
    value,
    property,
    getAdditionalPropertyValue,
    objectId,
    objectTypeId
  } = validationRequest;
  /**
   * This validator gets run for either the recurringbillingfrequency or the hs_recurring_billing_period
   * properties. Depending on which property was recently changed, we query the other via the additional
   * property hook.
   */
  const billingFrequency = (() => {
    if (property.name === 'recurringbillingfrequency') {
      return value;
    }
    return getAdditionalPropertyValue && getAdditionalPropertyValue('recurringbillingfrequency', objectId || undefined, objectTypeId);
  })();
  const period = (() => {
    if (property.name === 'hs_recurring_billing_period') {
      return value;
    }
    return getAdditionalPropertyValue && getAdditionalPropertyValue('hs_recurring_billing_period', objectId || undefined, objectTypeId);
  })();
  const isValid = doesBillingFrequencyEvenlyDividePeriod(period, billingFrequency);
  const errors = isValid ? [] : [{
    code: INVALID_BILLING_TERM_FREQUENCY_RATIO,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.propertyValidationErrorMessages.invalidBillingPeriodFrequencyRatio"
    })
  }];
  return {
    errors,
    validationRequest,
    validationStatus: isValid ? VALID : INVALID
  };
};

/**
 * Validator for ensuring that Term in months is an even multiple of Billing frequency in months.
 */
export const billingPeriodFrequencyPropertyValidator = validationRequest => Promise.resolve(createValidationDetails(validationRequest));